import { defineComponent as _defineComponent } from 'vue'
import {withDefaults} from "vue"

interface Props {
    my: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'borderHorizontal',
  props: {
    my: { default: "my-3" }
  },
  setup(__props: any) {

const props = __props as { my: string }





return { __sfc: true,props }
}

})